import { render, staticRenderFns } from "./dataAlarm.vue?vue&type=template&id=52eeb7ff&scoped=true&"
import script from "./dataAlarm.vue?vue&type=script&lang=js&"
export * from "./dataAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eeb7ff",
  null
  
)

export default component.exports